module.exports = __webpack_public_path__ + "static/media/x-font.40651b5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/resources/fonts/x-font.svg?53940796
// module id = 373
// module chunks = 0